import { TwilioClient, Options } from 'ha/types/Twilio';

const twilio = () => {
  let initializedP: Promise<TwilioClient> | null;

  return {
    init: (token: string, options?: Options) => {
      if (initializedP) {
        return initializedP;
      }

      initializedP = import(/* webpackChunkName: "twilio-chat" */ 'twilio-chat')
        .then(({ Client }) =>
          Client.create(token, {
            logLevel: options && options.debug ? 'error' : 'silent',
          }),
        )
        .catch(err => {
          initializedP = null;
          throw err;
        });

      return initializedP;
    },
  };
};
export { twilio };
